import { createContext } from "react";
export const AppSettingsContext = createContext(null);
